import { esbApi } from '@modules/rtk/esb-api';
import tagFactory from '@modules/rtk/utils/tagFactory';

/**
 * RTK Query endpoints for the advancement import (.txt) workflow.
 *
 * These replace the legacy redux-observable/XHR services in
 * `advancementUpload/duck/services.js`.
 */
export const advancementImportApi = esbApi.injectEndpoints({
  endpoints: builder => ({
    /**
     * @esbEndpoint POST /persons/advancementImports
     *
     * Uploads a vendor advancement import file (multipart FormData).
     */
    uploadAdvancementImport: builder.mutation<
      void,
      { payload: FormData; organizationGuid: string }
    >({
      query: arg => ({
        url: '/persons/advancementImports',
        method: 'POST',
        params: { organizationGuid: arg.organizationGuid },
        body: arg.payload,
      }),
      invalidatesTags: (_result, error, arg) =>
        error
          ? []
          : [tagFactory.AdvancementImports.orgImports(arg.organizationGuid)],
    }),

    /**
     * @esbEndpoint DELETE /persons/advancementImports/:importId
     *
     * Cancels/deletes a pending advancement import file.
     */
    cancelAdvancementImport: builder.mutation<
      void,
      { id: number; organizationGuid: string }
    >({
      query: arg => ({
        url: `/persons/advancementImports/${arg.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, error, arg) =>
        error
          ? []
          : [tagFactory.AdvancementImports.orgImports(arg.organizationGuid)],
    }),
  }),
});

export const {
  useUploadAdvancementImportMutation,
  useCancelAdvancementImportMutation,
} = advancementImportApi;
